/* unplugin-vue-components disabled */import script from "./CategoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryView.vue?vue&type=script&setup=true&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=7a890890&lang=scss"

const __exports__ = script;

export default __exports__